import React from "react";
import { Form } from "semantic-ui-react";
import CustomerForm from "@common/components/shared/CustomerForm";
import useSuspects from "@common/components/hooks/useSuspects";
import SuspiciousActivityAction from "@common/redux/actions/SuspiciousActivityAction";

const SuspectsForm = () => {
  const {
    onSelect,
    handleExists,
    handleNewSuspect,
    handleEditSuspect,
    handleRemoveSuspect,
  } = useSuspects();

  return (
    <>
      <Form.Field>
        <label>
          <b>Persons involved in suspicious activity:</b>
        </label>
      </Form.Field>
      <CustomerForm
        onSelect={onSelect}
        handleNewCustomer={handleNewSuspect}
        handleExists={handleExists}
        handleEditCustomer={handleEditSuspect}
        handleRemoveCustomer={handleRemoveSuspect}
        handleResetCustomer={SuspiciousActivityAction.reset}
      />
    </>
  );
};

export default SuspectsForm;
